export enum ADDRESS_FORM_CONTROL_NAME {
  LATITUDE = 'latitude',
  LONGITUDE = 'longitude'
}
export enum LABELS {
  CHARACTERS_LEFT = 'Characters left',
  ADD_FIST_NAME = '+ Insert First Name'
}
export enum REPLACE_KEY {
  FIRST_NAME = '[First Name]',
  FIRST_NAME_PASCAL = '[FirstName]'
}
export enum ERROR_MESSAGES {
  NFT_ALREADY_ADDED = "This NFT ID has already been added and can't be used again."
}

export enum CommonEnums {
  SELECT_FILE = 'SELECT FILE',
  ADD_MULTIPLE_IMAGE = 'Add Multiple Image'
}

export const MULTIPLE_IMAGE_UPLOAD_STRINGS = {
  REMOVE_IMAGE: 'Remove image',
  DRAG_TO_REORDER: 'Drag to reorder',
  PREVIEW_IMAGE_ALT: 'Image'
} as const;

export const MULTIPLE_IMAGE_UPLOAD_DRAG = {
  DROP_LIST_ORIENTATION: 'horizontal'
} as const;
